
import { Component, Vue } from "vue-property-decorator";
import {getPageAPIs, Util} from "@/common/util";
import DeviceConfigAPI from "@/common/api/deviceConfig";
export const pageApiList = getPageAPIs(DeviceConfigAPI);
@Component({})
export default class UserList extends Vue {
  private deviceConfigApi: any = new DeviceConfigAPI();
  private forms: any = {
    value: 0,
    input: "",
  };
  private form: any = {
    time: [], // 时间选择
  };
  private switch_value:number = 0
  private activated(): void {
    this.getTable();
    this.getPool()
  }
  private getTable(): void {
    this.deviceConfigApi.list(
      {
        ...this.form,
        page: this.tablePage.pageNo,
        limit: this.tablePage.pageSize,
      },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.totalCount = res.data.count;
        this.tablePage.pageNo = res.data.page;
        this.tablePage.pageSize = res.data.prepage;
      }
    );
  }

  private pool_list:any[] = []
  private getPool(): void {
    this.deviceConfigApi.pool({type:0},
        (res: any) => {
          this.pool_list = res.data.list;
        }
    );
  }



  private options: any = [];
  private addmembersshow: boolean = false;
  private addform = {
    device_no:'',
    pool_id:'',
  };
  private handleClose() {
    this.addmembersshow = false;
    this.addform = new Util().clearObject(this.addform);
  }
  private addForm(type = 1,row={}) {
    if(type===2){
      this.addform = {...row}
    }
    this.addmembersshow = true;
  }
  private add_submit(): void {
    this.deviceConfigApi.bind(this.addform, (res: any) => {
      this.addmembersshow = false;
      this.forms = new Util().clearObject(this.forms);
      this.membuy = res.data;
      this.getTable()
    });
  }
  private membuy: any = {};
  private addmembers(): void {
    this.addmembersshow = true;
  }
  private unBind(row: any): void {
    this.$confirm(`确认解绑设备码${row.device_no}吗？`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.deviceConfigApi.unbind(
          {id: row.id,},
          (res: any) => {
            Util.showToast("解绑成功");
            this.search();
          }
      );
    })


  }
  private pay: boolean = false;
  private check: number = 1;
  private changePayType(index: number): void {
    this.check = index;
  }
  private scanCode: boolean = false;
  private scanCodePay(): void {
    this.scanCode = true;
    this.getscanCode();
  }
  private buy_ok = [200, 400220, 400213];
  private buy_two = [400217, 400218, 400214];
  private buy_no = [400211, 400212, 400215, 400216, 400219, 400221];
  private auth_code: string = "";
  private getscanCode(): void {
    let that = this;
    let str = "";
    document.onkeydown = function (e: any) {
      console.log(str);
      if (e.target.tagName !== "BODY") {
        str = "";
      } else {
        if (e.keyCode !== 13) {
          if (e.keyCode >= 32 && e.keyCode <= 126) {
            let k = e.key;
            str += k;
          }
        } else {
          if (str) {
            console.log(str);
            that.auth_code = str;
            str = "";
            that.payrequest();
          }
        }
      }
    };
  }
  private payrequest(): void {
    this.deviceConfigApi.payrequest(
      {
        order_id: this.membuy.order_id,
        pay_type: this.check,
        biz_type: 5,
        auth_code: this.auth_code,
      },
      (res: any) => {
        if (this.buy_ok.includes(res.code)) {
          Util.showToast("支付成功");
          // this.renewal = false;
          // this.show_table = false;
          this.pay = false;
          this.scanCode = false;
          this.getTable();
        } else if (this.buy_two.includes(res.code)) {
          if (res.code == 400217) {
            Util.showToast("需要用户输入支付密码");
          } else if (res.code == 400218) {
            Util.showToast("付款码错误，请刷新二维码重试");
          } else if (res.code == 400214) {
            Util.showToast("支付失败，余额不足");
          }
        } else {
          this.scanCode = false;
          // this.pay=false
          // this.buygoods();
        }
      }
    );
  }

  /** end 导出excel */
  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private changeVoice(value:number):void{
    console.log(value)
    this.deviceConfigApi.setVoice({voice_broadcast:value}, (res: any) => {
      Util.showToast("设置成功");
    });
  }
}
